import CustomTabs from './customTabs'
export default CustomTabs
